<script>
import { Bar } from 'vue-chartjs';

// График «Получено / Израсходовано» (Э-7): два ряда столбцов, в подсказке — фактические даты интервала.
export default {
  name: 'WalletFlowChart',
  extends: Bar,
  props: {
    // [{ label, from, to, received, spent }]
    points: { type: Array, required: true },
    receivedLabel: { type: String, default: 'Получено' },
    spentLabel: { type: String, default: 'Израсходовано' },
  },
  watch: {
    points() {
      this.draw();
    },
  },
  mounted() {
    this.draw();
  },
  methods: {
    draw() {
      const { points } = this;
      this.renderChart({
        labels: points.map((p) => p.label),
        datasets: [
          { label: this.receivedLabel, backgroundColor: '#4f8bd6', data: points.map((p) => p.received) },
          { label: this.spentLabel, backgroundColor: '#f2a541', data: points.map((p) => p.spent) },
        ],
      }, {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: 'bottom' },
        scales: {
          yAxes: [{ ticks: { beginAtZero: true, precision: 0 } }],
          xAxes: [{ gridLines: { display: false } }],
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            title: (items) => {
              const p = points[items[0].index];
              return p.from === p.to ? p.from : `${p.from} — ${p.to}`;
            },
          },
        },
      });
    },
  },
};
</script>
